<template>
  <paginate
    class="custom-pagination"
    v-model="page"
    :page-count="pageCount"
    :page-range="pageNumber"
    :click-handler="handleChangePage"
    :prev-text="'<'"
    :next-text="'>'"
  >
  </paginate>
</template>

<script>
import Paginate from 'vuejs-paginate';

export default {
  props: ['pageCount', 'pageNumber'],
  components: { Paginate },
  data() {
    return {
      page: 1
    };
  },
  methods: {
    handleChangePage(pageNum) {
      this.$emit('handlePageChange', pageNum);
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-pagination {
  display: flex;
  ::v-deep li {
    margin: 0 5px;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #f3f5fa;
    border-radius: 4px;
    font-family: Inter-Regular;
    font-size: 14px;
    color: #828c9f;
    background-color: #ffffff;
    &.active {
      color: #ffffff;
      background-color: #5b6ef5;
    }
    a {
      color: inherit;
      text-decoration: inherit;
    }
  }
}
</style>
